import React from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'
import alphabeticalSortASC from 'utils/alphabeticalSortASC'

const getLabel = module => {
  return t(`modules.${module.module}.name`)
}

const SystemTab = connect(
  {
    modules: state`app.user.modules`,
    changeModule: signal`app.changeModule`
  },
  ({ modules, changeModule }) => {
    if (!modules) {
      return null
    }
    const items = modules
      .sort((a, b) => alphabeticalSortASC(getLabel(a), getLabel(b)))
      .reduce((acc, module) => {
        if (module.module !== 'mediabase') {
          const label = getLabel(module)
          acc.push({
            label,
            action: () => changeModule({ module: module.module })
          })
        }
        return acc
      }, [])
      .concat([{ label: getLabel({ module: 'mediabase' }) }])

    const position = (-items.length + 1) * 26

    return (
      <div className={css(styles.systemTab)} style={{ top: position }}>
        {items.map(item => {
          return (
            <div
              className={css(styles.systemTabItem)}
              key={item.label}
              onClick={item.action}
            >
              {item.label}
            </div>
          )
        })}
      </div>
    )
  }
)

export default SystemTab



// WEBPACK FOOTER //
// ./src/components/Header/systemTab.js